var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5918 9.40833C15.5144 9.33023 15.4222 9.26823 15.3206 9.22592C15.2191 9.18362 15.1102 9.16183 15.0002 9.16183C14.8901 9.16183 14.7812 9.18362 14.6797 9.22592C14.5781 9.26823 14.486 9.33023 14.4085 9.40833L11.6668 12.1583V5.83333C11.6668 5.61232 11.579 5.40036 11.4227 5.24408C11.2665 5.0878 11.0545 5 10.8335 5C10.6125 5 10.4005 5.0878 10.2442 5.24408C10.088 5.40036 10.0002 5.61232 10.0002 5.83333V12.1583L7.25849 9.40833C7.10157 9.25141 6.88874 9.16326 6.66682 9.16326C6.4449 9.16326 6.23207 9.25141 6.07515 9.40833C5.91823 9.56525 5.83008 9.77808 5.83008 10C5.83008 10.2219 5.91823 10.4347 6.07515 10.5917L10.2418 14.7583C10.3211 14.8342 10.4145 14.8937 10.5168 14.9333C10.6166 14.9774 10.7244 15.0002 10.8335 15.0002C10.9425 15.0002 11.0504 14.9774 11.1502 14.9333C11.2524 14.8937 11.3459 14.8342 11.4252 14.7583L15.5918 10.5917C15.6699 10.5142 15.7319 10.422 15.7742 10.3205C15.8165 10.2189 15.8383 10.11 15.8383 10C15.8383 9.88999 15.8165 9.78107 15.7742 9.67952C15.7319 9.57797 15.6699 9.4858 15.5918 9.40833Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/down arrow.f582817e8d4facc9eb9a0b6765e07f86.svg";
export { ForwardRef as ReactComponent };